import React from "react";
import style from "./form.module.css";

const Title = ({ title }) => {
  return <p className={style.formTitle}>{title}</p>;
};

export default Title;
